export default {"src":"https://search.prod.wiggot.com/_next/static/media/monopolioLabelWhite.b5280fff.svg","height":14,"width":73,"blurWidth":0,"blurHeight":0};